import { ChatMessage } from "../interfaces";
import firebase from "firebase";

//Global
export const CONTROL_PANEL_INIT = "CONTROL_PANEL_INIT";
export const CONTROL_PANEL_INIT_COMPLETE = "CONTROL_PANEL_INIT_COMPLETE";
export const LOG = "LOG";
export const DISPLAY_ERROR = "DISPLAY_ERROR";
export const DISPLAY_QUICK_MESSAGE = "DISPLAY_QUICK_MESSAGE";
export const REMOVE_QUICK_MESSAGE = "REMOVE_QUICK_MESSAGE";
export const LOAD_METADATA = "LOAD_METADATA";
export const LOAD_TIMEZONES_SUCCESS = "LOAD_TIMEZONES_SUCCESS";
export const LOAD_TIMEZONES_FAIL = "LOAD_TIMEZONES_FAIL";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";
export const CREATE_ITEM = "CREATE_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const UPSERT_FIREBASE_OBJECT = "UPSERT_FIREBASE_OBJECT";
export const TOGGLE_APP_PREVIEW = "TOGGLE_APP_PREVIEW";

//User
export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const USER_DOES_NOT_EXIST = "USER_DOES_NOT_EXIST";
export const SELECT_USER = "SELECT_USER";
export const SELECT_USER_SUCCESS = "SELECT_USER_SUCCESS";

//Auth
export const TRACK_AUTH_STATUS = "TRACK_AUTH_STATUS";
export const AUTH_STATUS_CHANGED = "AUTH_STATUS_CHANGED";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

//APPS
export const LOAD_APPS = "LOAD_APPS";
export const LOAD_APPS_SUCCESS = "LOAD_APPS_SUCCESS";
export const LOAD_APPS_FAIL = "LOAD_APPS_FAIL";
export const LOAD_USERS = "LOAD_USERS";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAIL = "LOAD_USERS_FAIL";
export const SELECT_APP = "SELECT_APP";
export const CREATE_APP = "CREATE_APP";
export const CREATE_APP_SUCCESS = "CREATE_APP_SUCCESS";
export const CREATE_APP_FAIL = "CREATE_APP_FAIL";
export const EDIT_APP = "EDIT_APP";
export const EDIT_APP_SUCCESS = "EDIT_APP_SUCCESS";
export const EDIT_APP_FAIL = "EDIT_APP_FAIL";
export const DELETE_APP = "DELETE_APP";
export const DELETE_APP_SUCCESS = "DELETE_APP_SUCCESS";
export const DELETE_APP_FAIL = "DELETE_APP_FAIL";
export const EDIT_APP_NAVIGATION = "EDIT_APP_NAVIGATION";
export const EDIT_APP_NAVIGATION_SUCCESS = "EDIT_APP_NAVIGATION_SUCCESS";
export const LOAD_APP_NAVIGATION = "LOAD_APP_NAVIGATION";
export const LOAD_APP_NAVIGATION_SUCCESS = "LOAD_APP_NAVIGATION_SUCCESS";

//Experiences
export const LOAD_EXPERIENCES = "LOAD_EXPERIENCES";
export const LOAD_EXPERIENCES_SUCCESS = "LOAD_EXPERIENCES_SUCCESS";
export const LOAD_EXPERIENCES_FAIL = "LOAD_EXPERIENCES_FAIL";
export const LOAD_EXPERIENCE = "LOAD_EXPERIENCE";
export const LOAD_EXPERIENCE_SUCCESS = "LOAD_EXPERIENCE_SUCCESS";
export const LOAD_EXPERIENCE_FAIL = "LOAD_EXPERIENCE_FAIL";
export const SELECT_EXPERIENCE = "SELECT_EXPERIENCE";
export const CREATE_EXPERIENCE = "CREATE_EXPERIENCE";
export const CREATE_EXPERIENCE_SUCCESS = "CREATE_EXPERIENCE_SUCCESS";
export const CREATE_EXPERIENCE_FAIL = "CREATE_EXPERIENCE_FAIL";
export const EDIT_EXPERIENCE = "EDIT_EXPERIENCE";
export const EDIT_EXPERIENCE_SUCCESS = "EDIT_EXPERIENCE_SUCCESS";
export const EDIT_EXPERIENCE_FAIL = "EDIT_EXPERIENCE_FAIL";
export const DELETE_EXPERIENCE = "DELETE_EXPERIENCE";
export const DELETE_EXPERIENCE_SUCCESS = "DELETE_EXPERIENCE_SUCCESS";
export const DELETE_EXPERIENCE_FAIL = "DELETE_EXPERIENCE_FAIL";
export const EDIT_EXPERIENCE_NAVIGATION = "EDIT_EXPERIENCE_NAVIGATION";
export const EDIT_EXPERIENCE_NAVIGATION_SUCCESS = "EDIT_EXPERIENCE_NAVIGATION_SUCCESS";
export const LOAD_EXPERIENCE_NAVIGATION = "LOAD_EXPERIENCE_NAVIGATION";
export const LOAD_EXPERIENCE_NAVIGATION_SUCCESS = "LOAD_EXPERIENCE_NAVIGATION_SUCCESS";

//Pages
export const LOAD_PAGES = "LOAD_PAGES";
export const LOAD_PAGES_SUCCESS = "LOAD_PAGES_SUCCESS";
export const LOAD_PAGES_FAIL = "LOAD_PAGES_FAIL";
export const CREATE_PAGE = "CREATE_PAGE";
export const CREATE_PAGE_SUCCESS = "CREATE_PAGE_SUCCESS";
export const CREATE_PAGE_FAIL = "CREATE_PAGE_FAIL";
export const SELECT_PAGE = "SELECT_PAGE";
export const SELECT_PAGE_SUCCESS = "SELECT_PAGE_SUCCESS";
export const SELECT_PAGE_FAILURE = "SELECT_PAGE_FAILURE";
export const RESET_CURRENT_PAGE = "RESET_CURRENT_PAGE";
export const EDIT_PAGE = "EDIT_PAGE";
export const EDIT_PAGE_SUCCESS = "EDIT_PAGE_SUCCESS";
export const EDIT_PAGE_FAILURE = "EDIT_PAGE_FAILURE";
export const DELETE_PAGE = "DELETE_PAGE";
export const DELETE_PAGE_SUCCESS = "DELETE_PAGE_SUCCESS";
export const DELETE_PAGE_FAILURE = "DELETE_PAGE_FAILURE";
export const SET_CHAT_PAGES = "SET_CHAT_PAGES";
export const SET_POLLING_PAGES = "SET_POLLING_PAGES";

//Integrations
export const LOAD_INTEGRATIONS = "LOAD_INTEGRATIONS";
export const LOAD_INTEGRATIONS_SUCCESS = "LOAD_INTEGRATIONS_SUCCESS";
export const LOAD_INTEGRATIONS_FAIL = "LOAD_INTEGRATIONS_FAIL";
export const CREATE_INTEGRATION = "CREATE_INTEGRATION";
export const CREATE_INTEGRATION_SUCCESS = "CREATE_INTEGRATION_SUCCESS";
export const CREATE_INTEGRATION_FAIL = "CREATE_INTEGRATION_FAIL";
export const SELECT_INTEGRATION = "SELECT_INTEGRATION";
export const SELECT_INTEGRATION_SUCCESS = "SELECT_INTEGRATION_SUCCESS";
export const SELECT_INTEGRATION_FAILURE = "SELECT_INTEGRATION_FAILURE";
export const RESET_CURRENT_INTEGRATION = "RESET_CURRENT_INTEGRATION";
export const EDIT_INTEGRATION = "EDIT_INTEGRATION";
export const EDIT_INTEGRATION_SUCCESS = "EDIT_INTEGRATION_SUCCESS";
export const EDIT_INTEGRATION_FAILURE = "EDIT_INTEGRATION_FAILURE";
export const DELETE_INTEGRATION = "DELETE_INTEGRATION";
export const DELETE_INTEGRATION_SUCCESS = "DELETE_INTEGRATION_SUCCESS";
export const DELETE_INTEGRATION_FAILURE = "DELETE_INTEGRATION_FAILURE";

//Modules
export const LOAD_MODULES = "LOAD_MODULES";
export const LOAD_MODULES_SUCCESS = "LOAD_MODULES_SUCCESS";
export const LOAD_MODULES_FAIL = "LOAD_MODULES_FAIL";

//Themes
export const GET_THEMES = "GET_THEMES";
export const GET_THEMES_SUCCESS = "GET_THEMES_SUCCESS";
export const GET_THEMES_FAILURE = "GET_THEMES_FAILURE";
export const CREATE_THEME = "CREATE_THEME";
export const CREATE_THEME_SUCCESS = "CREATE_THEME_SUCCESS";
export const CREATE_THEME_FAILURE = "CREATE_THEME_FAILURE";
export const DELETE_THEME = "DELETE_THEME";
export const DELETE_THEME_SUCCESS = "DELETE_THEME_SUCCESS";
export const DELETE_THEME_FAILURE = "DELETE_THEME_FAILURE";
export const SELECT_THEME = "SELECT_THEME";
export const SELECT_THEME_SUCCESS = "SELECT_THEME_SUCCESS";
export const SELECT_THEME_FAILURE = "SELECT_THEME_FAILURE";
export const RESET_CURRENT_THEME = "RESET_CURRENT_THEME";
export const LOAD_DEFAULT_THEME = "LOAD_DEFAULT_THEME";
export const LOAD_DEFAULT_THEME_SUCCESS = "LOAD_DEFAULT_THEME_SUCCESS";
export const LOAD_DEFAULT_THEME_FAILURE = "LOAD_DEFAULT_THEME_FAILURE";
export const EDIT_THEME = "EDIT_THEME";
export const EDIT_THEME_SUCCESS = "EDIT_THEME_SUCCESS";
export const EDIT_THEME_FAILURE = "EDIT_THEME_FAILURE";
export const PICKING_THEME_TEMPLATE = "PICKING_THEME_TEMPLATE";
export const PICKING_THEME_TEMPLATE_FINISHED = "PICKING_THEME_TEMPLATE_FINISHED";

//Topics
export const LOAD_TOPICS = "LOAD_TOPICS";
export const LOAD_TOPICS_SUCCESS = "LOAD_TOPICS_SUCCESS";

//Lookups
export const GET_CULTURES = "GET_CULTURES";
export const GET_CULTURES_SUCCESS = "GET_CULTURES_SUCCESS";
export const GET_CULTURES_FAILURE = "GET_CULTURES_FAILURE";
//Posts
export const LOAD_POSTS = "LOAD_POSTS";
export const LOAD_POSTS_SUCCESS = "LOAD_POSTS_SUCCESS";
export const LOAD_POSTS_FAIL = "LOAD_POSTS_FAIL";
export const SELECT_POST = "SELECT_POST";
export const SELECT_POST_SUCCESS = "SELECT_POST_SUCCESS";
export const SELECT_POST_FAILURE = "SELECT_POST_FAILURE";
export const RESET_CURRENT_POST = "RESET_CURRENT_POST";

//Sessions
export const LOAD_SESSIONS = "LOAD_SESSIONS";
export const LOAD_SESSIONS_SUCCESS = "LOAD_SESSIONS_SUCCESS";
export const LOAD_SESSIONS_FAIL = "LOAD_SESSIONS_FAIL";
export const SELECT_SESSION = "SELECT_SESSION";
export const SELECT_SESSION_SUCCESS = "SELECT_SESSION_SUCCESS";
export const SELECT_SESSION_FAILURE = "SELECT_SESSION_FAILURE";
export const RESET_CURRENT_SESSION = "RESET_CURRENT_SESSION";

//Notifications
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS";
export const LOAD_NOTIFICATIONS_FAIL = "LOAD_NOTIFICATIONS_FAIL";
export const SELECT_NOTIFICATION = "SELECT_NOTIFICATION";
export const SELECT_NOTIFICATION_SUCCESS = "SELECT_NOTIFICATION_SUCCESS";
export const SELECT_NOTIFICATION_FAILURE = "SELECT_NOTIFICATION_FAILURE";
export const RESET_CURRENT_NOTIFICATION = "RESET_CURRENT_NOTIFICATION";

//Validation
export const UPDATE_FORM_ERRORS = "UPDATE_FORM_ERRORS";

//Responsive
export const UPDATE_RESPONSIVE = "UPDATE_RESPONSIVE";
export const TOGGLE_SIDE_MENU = "TOGGLE_SIDE_MENU";
export const HIDE_SIDE_MENU = "HIDE_SIDE_MENU";
export const SHOW_SIDE_MENU = "SHOW_SIDE_MENU";
export const DROPDOWN_OPEN = "DROPDOWN_OPEN";
export const DROPDOWN_CLOSE = "DROPDOWN_CLOSE";

//App Config
export const LOAD_APP_CONFIG = "LOAD_APP_CONFIG";
export const LOAD_APP_CONFIG_SUCCESS = "LOAD_APP_CONFIG_SUCCESS";
export const LOAD_APP_CONFIG_FAILURE = "LOAD_APP_CONFIG_FAILURE";
export const SAVE_APP_CONFIG = "SAVE_APP_CONFIG";
export const SAVE_APP_CONFIG_SUCCESS = "SAVE_APP_CONFIG_SUCCESS";
export const SAVE_APP_CONFIG_FAILURE = "SAVE_APP_CONFIG_FAILURE";
export const CLEAR_APP_CONFIG = "CLEAR_APP_CONFIG";

//OAuth
export const SAVE_AUTH_CODE = "SAVE_AUTH_CODE";
export const SAVE_AUTH_CODE_SUCCESS = "SAVE_AUTH_CODE_SUCCESS";
export const SAVE_AUTH_CODE_FAILURE = "SAVE_AUTH_CODE_FAILURE";
export const REFRESH_ACCESS_TOKEN = "REFRESH_ACCESS_TOKEN";
export const REFRESH_ACCESS_TOKEN_SUCCESS = "REFRESH_ACCESS_TOKEN_SUCCESS";
export const REFRESH_ACCESS_TOKEN_FAILURE = "REFRESH_ACCESS_TOKEN_FAILURE";
export const CAN_REFRESH = "CAN_REFRESH";
export const CANNOT_REFRESH = "CANNOT_REFRESH";

//Chat

export interface ChatState {
	messages: { [key: string]: ChatMessage };
	chatId?: string;
	latestMessage?: firebase.firestore.Timestamp;
	limitMessages: boolean;
	newMessages: boolean;
	scrolledUp: boolean;
	userStatus: {
		[uid: string]: boolean;
	};
	showModal: boolean;
	modalData: ModalData;
}

export interface ModalData {
	title: string;
	message: string;
	closeButtonText: string;
}

export const SET_CHAT_DATA: string = "SET_CHAT_DATA";
export const LIKE_CHAT_MESSAGE: string = "LIKE_CHAT_MESSAGE";
export const FLAG_CHAT_MESSAGE: string = "FLAG_CHAT_MESSAGE";
export const DELETE_CHAT_MESSAGE: string = "DELETE_CHAT_MESSAGE";
export const SET_LIMIT_MESSAGES: string = "SET_LIMIT_MESSAGES";
export const SET_SCROLLED_UP: string = "SET_SCROLLED_UP";
export const PIN_CHAT_MESSAGE: string = "PIN_CHAT_MESSAGE";
export const USER_STATUS_CHANGED: string = "USER_STATUS_CHANGED";
export const SHOW_MODAL_ALERT: string = "SHOW_MODAL_ALERT";
export const HIDE_MODAL_ALERT: string = "HIDE_MODAL_ALERT";

export interface ISetChat {
	messages: { [key: string]: ChatMessage };
	chatId: string;
	latestMessage?: firebase.firestore.Timestamp;
	removeOldMessages: boolean;
}

export interface ILikeChat {
	messageId: string;
	uid: string;
}

export interface IDeleteChat {
	messageId: string;
}

export interface IPinChat {
	messageId: string;
	newDupeChatId?: string;
}
export interface ILimitMessages {
	limitMessages: boolean;
}

export interface IUserStatusChanged {
	status: boolean;
	uid: string;
}

export interface IShowModalAlert {
	showModal: boolean;
	modalData: ModalData;
}

export interface SetChatData {
	type: typeof SET_CHAT_DATA;
	payload: ISetChat;
}

export interface LikeChatData {
	type: typeof LIKE_CHAT_MESSAGE;
	payload: ILikeChat;
}

export interface FlagChatData {
	type: typeof FLAG_CHAT_MESSAGE;
	payload: ILikeChat;
}

export interface DeleteChatData {
	type: typeof DELETE_CHAT_MESSAGE;
	payload: IDeleteChat;
}

export interface PinChatData {
	type: typeof PIN_CHAT_MESSAGE;
	payload: IPinChat;
}

export interface SetLimitMessages {
	type: typeof SET_LIMIT_MESSAGES;
	payload: ILimitMessages;
}

export interface SetScrolledUp {
	type: typeof SET_SCROLLED_UP;
	payload: boolean;
}

export interface UserStatusChanged {
	type: typeof USER_STATUS_CHANGED;
	payload: IUserStatusChanged;
}

export interface ShowModalAlert {
	type: typeof SHOW_MODAL_ALERT;
	payload: IShowModalAlert;
}

export interface HideModalAlert {
	type: typeof HIDE_MODAL_ALERT;
	payload: boolean;
}

export type ChatActionTypes =
	| SetChatData
	| LikeChatData
	| FlagChatData
	| DeleteChatData
	| SetLimitMessages
	| SetScrolledUp
	| PinChatData
	| UserStatusChanged
	| ShowModalAlert
	| HideModalAlert;
